import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StContentArea = styled.div<{
  zIndex?: number
  gridArea: string
  scrollable?: boolean
  flexInner?: boolean // render as flex container
  divider?: boolean
}>`
  max-width: 100%;
  height: 100%;
  grid-area: content;
  position: relative;
  z-index: ${({ zIndex }) => zIndex ?? 0};

  ${({ divider, theme }) =>
    divider &&
    `
    border-right: 1px solid ${theme.Colors.Neutrals.Light};
  `}

  ${({ gridArea }) => `
    background-color: ${gridArea === 'content-detail' ? 'white' : 'inherit'};
    @media ${breakpoints.m} {
      grid-area: ${gridArea};
    }
  `}

  ${({ scrollable }) => `
    overflow-y: ${scrollable ? 'auto' : 'hidden'};
  `}

    ${({ flexInner }) =>
      flexInner &&
      `
    display: flex;
    flex-direction: column;
    overflow: auto;
  `}
`

export { StContentArea }
